import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  dateFrom: '',
  dateTo: '',
  purposes: [],
  statuses: [],
  totDays: '',
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  dateFrom: 'ge',
  dateTo: 'le',
  purposes: 'in',
  statuses: 'in',
  totDays: 'eq',
};

export const getFiltersMapper =
  (purposeTypes: TypeDict[], statuses: TypeDict[]): Mapper =>
  (key, value) => {
    if (key === 'dateFrom') {
      return ['startDate', value];
    }

    if (key === 'dateTo') {
      return ['endDate', value];
    }

    if (key === 'purposes') {
      const purposeTypesResultValue = (value as string[]).map(
        (item) =>
          purposeTypes.find((purposeType) => purposeType.codeDesc === item)!
            .codeNum
      );
      return ['leaveTypeID', purposeTypesResultValue];
    }

    if (key === 'totDays') {
      return ['totDays', Number(value)];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['reqStatusId', statusResultValue];
  };
